import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export const queryParamKey = 'redirectQueryParam';

export const biometryStatusKey = 'biometryStatus';

export const BIOMETRY_STATUS = Object.freeze({
  PENDING: 'pending',
  ACTIVE: 'active',
  FAILED: 'failed',
  DECLINED: 'declined',
  EXPIRED: 'expired',
  CANCELED: 'canceled',
});

export const COMMON_BIOMETRY_ROUTES = Object.freeze({
  [BIOMETRY_STATUS.PENDING]: WEB_ROUTES.BIOMETRY_LOADING,
  [BIOMETRY_STATUS.FAILED]: WEB_ROUTES.BIOMETRY_LOADING,
  [BIOMETRY_STATUS.DECLINED]: WEB_ROUTES.BIOMETRY,
  [BIOMETRY_STATUS.EXPIRED]: WEB_ROUTES.BIOMETRY,
  [BIOMETRY_STATUS.CANCELED]: WEB_ROUTES.BIOMETRY,
});

export const BiometryProfileRoutes = Object.freeze({
  [BIOMETRY_STATUS.ACTIVE]: WEB_ROUTES.PROFILE_EDIT,
  ...COMMON_BIOMETRY_ROUTES,
});

export const BiometryApplyCardRoutes = Object.freeze({
  [BIOMETRY_STATUS.ACTIVE]: WEB_ROUTES.APPLICATION_APPLY,
  ...COMMON_BIOMETRY_ROUTES,
});

export const BiometryRedirectQueryParam = Object.freeze({
  profile: 'profile',
  apply: 'apply',
});

export const BiometryRedirectPath = Object.freeze({
  [BiometryRedirectQueryParam.profile]: WEB_ROUTES.PROFILE,
  [BiometryRedirectQueryParam.apply]: WEB_ROUTES.APPLICATION_APPLY,
});

export const BiometryRedirectRoutes = Object.freeze({
  [BiometryRedirectQueryParam.profile]: BiometryProfileRoutes,
  [BiometryRedirectQueryParam.apply]: BiometryApplyCardRoutes,
});

export const CreateBiometryRequestTrigger = Object.freeze({
  [BiometryRedirectQueryParam.apply]: 'adding_card',
  [BiometryRedirectQueryParam.profile]: 'changing_profile',
});
